import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_download",
  "use": "icon_download-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 16\" id=\"icon_download\"><path d=\"M8.778 10.334V1m0 9.334L5.667 7.222m3.11 3.112l3.112-3.112M1 11.888l.483 1.933A1.556 1.556 0 002.993 15h11.57c.714 0 1.336-.486 1.51-1.179l.483-1.933\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol